import { gql } from "@apollo/client"

export const EDIT_COMPANY_MUTATION = gql`
mutation EditCompany($input: EditCompanyInput!)
{
  editCompany(input:$input){
    __typename
    company {
      id
      type
      name
      # companyConsentPolicy{
      #   needParentalConsent
      #   autoParentalConsent
      #   timeoutWindow
      # }
      # companyInterventionPolicy{
      #   abuseAtHome
      #   safeAtHome
      #   suicide
      # }
    }
      errors {
        __typename
        ... on UnknownError {
          message
        }
        ... on ValidationError {
          errors {
            fieldName
            messages
          }
        },
        ... on EntityNotFoundError {
          message
        }
      }
  }
}`